/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchTournamentStage = {
    properties: {
        originalStartTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        matchType: {
            type: 'string',
            isRequired: true,
        },
        alternativeStartTime: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date-time',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        firstHalfEndTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        secondHalfStartTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        matchBoardLoaded: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        endTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        kickedOff: {
            type: 'boolean',
            isRequired: true,
        },
        fixedDate: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date-time',
            }, {
                type: 'null',
            }],
        },
        team1: {
            type: 'any-of',
            contains: [{
                type: 'TeamListWithoutLeagues',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        team2: {
            type: 'any-of',
            contains: [{
                type: 'TeamListWithoutLeagues',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        team1Placeholder: {
            type: 'string',
            isRequired: true,
        },
        team2Placeholder: {
            type: 'string',
            isRequired: true,
        },
        goal1: {
            type: 'number',
            isRequired: true,
        },
        goal2: {
            type: 'number',
            isRequired: true,
        },
        cancelled: {
            type: 'boolean',
            isRequired: true,
        },
        nextMatchId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        location: {
            type: 'any-of',
            contains: [{
                type: 'Location',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        events: {
            type: 'array',
            contains: {
                type: 'EventType',
            },
            isRequired: true,
        },
        tournament: {
            type: 'TournamentMinimal',
            isRequired: true,
        },
        tournamentStage: {
            type: 'GroupStageMinimal',
            isRequired: true,
        },
    },
} as const;
